import React from 'react';

const FeesChargesPage = React.lazy(() => import('./FeesChargesPage'));

const FeesChargesConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/fees-charges',
			element: (
				<React.Suspense fallback={<>...</>}>
					<FeesChargesPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default FeesChargesConfig;
